import { Link } from "react-router-dom";

import Logo from "../Logo/Logo";
import ColorSwitcher from "../ColorSwitcher/ColorSwitcher";
import styles from "./MobileNavBar.module.css";

/**
 * Mobile top bar.
 *
 * Intentionally thin: on a phone the primary navigation is the bottom
 * tab bar (PRD §10), so this bar carries only identity and small actions.
 * The template's offcanvas drawer was removed with its placeholder links.
 */
const MobileNavBar = ({ homeUrl = "/", children }) => (
  <header className={`${styles.NavBar} d-lg-none`}>
    <div className="container d-flex align-items-center gap-2">
      <Link
        to={homeUrl}
        className={styles.brand}
        aria-label="I don't know football, home"
      >
        <Logo size="sm" animatedMark />
      </Link>

      <div className={styles.actions}>
        {children}
        <ColorSwitcher />
      </div>
    </div>
  </header>
);

export default MobileNavBar;
